/**
 * JS for ACF: Flexible Content > Layouts > Produits apparentés
 */

const sliderRelatedProducts = () => {
  const sectionsSliderRelatedProducts = document.querySelectorAll(
    ".layout-related-products"
  );

  if (sectionsSliderRelatedProducts.length > 0) {
    sectionsSliderRelatedProducts.forEach((section) => {
      const sliderNavigationContainer =
        section.querySelector(".slider-navigation");
      const sliderProduct = section.querySelector(".products-slider");

      // not navigation container, no slider
      if (!sliderNavigationContainer) {
        return;
      }

      const sliderProductSwiper = new Swiper(sliderProduct, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: sliderNavigationContainer.querySelector(
            ".swiper-button-next"
          ),
          prevEl: sliderNavigationContainer.querySelector(
            ".swiper-button-prev"
          ),
        },
        breakpoints: {
          560: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          920: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 78,
          },
        },
      });
    });
  }
};

sliderRelatedProducts();
